module.exports = __webpack_public_path__ + "img/fb.ac8d894e.png";